import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { PortalPedidoAbrirRequest } from '../../requests/compras/portal-pedido-abrir.request';
import { PortalPedidoConfirmarRequest } from '../../requests/compras/portal-pedido-confirmar.request';
import { PortalPedidoDetalheResponse } from '../../responses/compras/portal-pedido-detalhe.response';
import { PortalPedidoResumoResponse } from '../../responses/compras/portal-pedido-resumo.response';

// Portal PÚBLICO do pedido — endpoints anônimos (sem token de usuário).
// Não usa addHeaderToken nem o handleError global (que redireciona no 401).
@Injectable({
  providedIn: 'root',
})
export class PortalPedidoService {
  private readonly apiUrl: string = environment.urlApiCompras + 'PortalPedido';

  constructor(private httpClient: HttpClient) {}

  private get options(): { headers: HttpHeaders } {
    return { headers: new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' }) };
  }

  public resumo(token: string): Observable<PortalPedidoResumoResponse> {
    return this.httpClient
      .get<PortalPedidoResumoResponse>(`${this.apiUrl}/${token}`, this.options)
      .pipe(catchError(this.handleError));
  }

  public abrir(token: string, documento: string): Observable<PortalPedidoDetalheResponse> {
    const request: PortalPedidoAbrirRequest = { documento };
    return this.httpClient
      .post<PortalPedidoDetalheResponse>(`${this.apiUrl}/${token}/abrir`, request, this.options)
      .pipe(catchError(this.handleError));
  }

  public confirmar(token: string, documento: string): Observable<PortalPedidoDetalheResponse> {
    const request: PortalPedidoConfirmarRequest = { documento };
    return this.httpClient
      .post<PortalPedidoDetalheResponse>(`${this.apiUrl}/${token}/confirmar`, request, this.options)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    const msg = error.error instanceof ErrorEvent
      ? error.error.message
      : `Código do erro: ${error.status}`;
    return throwError(() => new Error(msg));
  }
}
